import src from "IMAGE";
export default { src, width: 800, height: 533, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/webp;base64,UklGRlgAAABXRUJQVlA4TEsAAAAvBwABAM1VICICHgiwCQAAAIBtvQAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDe2wEAgIjI7Otapp91BFUL/YfWcLBDBAMA"};
